"use client"

import { ReactNode } from "react"

type Props = {
  children: ReactNode
  className?: string
}

export default function TitleS({
  children,
  className = "",
}: Props) {
  return (
    <h3
      className={`
        text-xs
        font-bold
        leading-4

        uppercase
        tracking-wider

        ${className}
      `}
    >
      {children}
    </h3>
  )
}